import * as React from "react"
const IconGuestDiscount = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={63}
        height={62}
        fill="none"
        {...props}
    >
        <rect width={62} height={62} x={0.5} fill="#E7F0FE" rx={31} />
        <path
            stroke="#6C6C82"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M38.752 45.503v-3.167a6.334 6.334 0 0 0-6.334-6.334H21.335A6.334 6.334 0 0 0 15 42.336v3.167m22.209-28.027a6.336 6.336 0 0 1-.054 11.737m9.515 16.29v-3.167a6.334 6.334 0 0 0-4.75-6.128m-8.71-12.874a6.334 6.334 0 1 1-12.668 0 6.334 6.334 0 0 1 12.668 0Z"
        />
    </svg>
)
export default IconGuestDiscount
